import { styled } from "@mui/material";
import { TABLET_SCREEN_SIZE } from "../../../../AppNavigation/constants";
import { useAppSelector } from "@/redux/hooks";
import { getCartCounts } from "@/redux/selectors";
import { scaleFont } from "@/utils/font";
import { SolidButton } from "@/components/StoreComponents/StoreButton";
import { useState } from "react";

const OuterContainer = styled("div")(({ theme }) => ({
  boxSizing: "border-box",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "52px",
  minWidth: "52px",
  height: "52px",
  minHeight: "52px",
  cursor: "pointer",
  fontWeight: theme.settings?.fonts?.fontWeight,
  border: `1px solid`,
  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
    width: "46px",
    minWidth: "46px",
    height: "46px",
    minHeight: "46px",
  },
}));

const InnerButton = styled(SolidButton)(({ theme }) => ({
  boxSizing: "border-box",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "37px",
  height: "37px",
  fontWeight: theme.settings?.fonts?.fontWeight,
  fontSize: scaleFont(theme.typography.fontSize, 20),

  [`@media screen and (max-width: ${TABLET_SCREEN_SIZE}px)`]: {
    width: "32px",
    height: "32px",
    fontSize: scaleFont(theme.typography.fontSize, 14),
  },
}));

const BagButton = ({ onClick }: { onClick: () => void }) => {
  const cartCount = useAppSelector(getCartCounts);
  const [border, setBorder] = useState<string | null>(null);
  const [borderRadius, setBorderRadius] = useState<string | null>(null);

  return (
    <OuterContainer
      className="bc-bag-button-outter"
      onClick={onClick}
      sx={{
        border,
        borderRadius,
      }}
    >
      <InnerButton
        ref={(ref) => {
          if (ref) {
            // share border styles with outerContainer. This could be simplified by just using an outline with offset
            const computedStyles = window.getComputedStyle(ref);
            setBorder(computedStyles.border);
            setBorderRadius(computedStyles.borderRadius);
          }
        }}
        className="bc-bag-button-inner"
      >
        {cartCount}
      </InnerButton>
    </OuterContainer>
  );
};

export default BagButton;
